import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import LoadingAnimation from '@/assets/Loading.lottie';
import { cn } from '@/lib/utils';

export interface LoadingSpinnerProps {
  /** Size of the spinner in pixels (default: 120) */
  size?: number;
  /** Additional CSS classes */
  className?: string;
}

export function LoadingSpinner({ size = 120, className }: LoadingSpinnerProps) {
  return (
    <div className={cn('flex items-center justify-center', className)} style={{ width: size, height: size }}>
      <DotLottieReact src={LoadingAnimation} loop autoplay style={{ width: '100%', height: '100%' }} />
    </div>
  );
}

